import { Component, EventEmitter, Input, Output } from '@angular/core';

type smallCardLinkColorStyle = 'normal' | 'inverted';
type smallCardLinkFontSize = 'regular' | 'small';

@Component({
  selector: 'app-small-card-link',
  templateUrl: './small-card-link.component.html',
  styleUrls: ['./small-card-link.component.scss']
})
export class SmallCardLinkComponent {
  @Input() text: string;
  @Input() iconName: string;
  @Input() iconColor = 'white';
  @Input() colorStyle: smallCardLinkColorStyle = 'normal';
  @Input() fontSize: smallCardLinkFontSize = 'regular';
  @Output() clickEvent = new EventEmitter();

  public emitClick(): void {
    this.clickEvent.emit();
  }
}
